export default __webpack_public_path__ + "static/media/spinner.9a2f1ee5.gif";